import React from "react";
import "./Sectors.css";

const sectors = [
  {
    number: "01",
    title: "Power sector",
    description: "Precision components, seals and assemblies built for power generation and maintenance applications.",
  },
  {
    number: "02",
    title: "Energy",
    description: "Reliable engineering solutions for demanding energy, oil and gas environments.",
  },
  {
    number: "03",
    title: "Fusion",
    description: "Precision components and assemblies engineered for demanding fusion applications.",
  },
  {
    number: "04",
    title: "Packaging & dairy",
    description: "Hygienic, durable components and assemblies made for continuous production systems.",
  },
];

const Sectors = () => (
  <section className="sectors" aria-labelledby="sectors-title">
    <div className="sectors__heading">
      <div>
        <p className="sectors__eyebrow">Sectors</p>
        <h2 id="sectors-title">Built for critical<br />industries</h2>
      </div>
      <p className="sectors__intro">
        Experience in demanding environments shapes how we plan, document and
        verify every product we deliver.
      </p>
    </div>
    <div className="sectors__grid">
      {sectors.map((sector) => (
        <article className="sector-card" key={sector.number}>
          <span className="sector-card__number">{sector.number}</span>
          <h3>{sector.title}</h3>
          <p>{sector.description}</p>
        </article>
      ))}
    </div>
  </section>
);

export default Sectors;
